import {
  Avatar,
  Box,
  Button,
  Container,
  TextField,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AvatarImg from "../../assets/profile_avatar.png";
import Grid from "@mui/material/Grid";

import React, { useEffect, useRef, useState } from "react";

import {
  GetUserProfileApi,
  UpdateUserProfileApi,
  UpdateUserProfileImageApi,
  deleteUserRequest,
  getUserProfileImg,
} from "./myProfileApi";
import Swal from "sweetalert2";
import Language from "./languageModal";
import { getData, updateProfile } from "./myProfileCustomApiHandler";
import { validationUpdateProfile } from "./myProfileValidation";
import { swalAlertPopProps } from "../../utils/commonUtils";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { useDispatch, useSelector } from "react-redux";
import AccountSwitcherModal from "./AccountSwitcherModal";
import { setSwitchAccount } from "../../app/store/reducer";
export default function MyProfile() {
  const [imageContainer, setImageContainer] = useState("");
  const profileImgRef = useRef();
  const [open, setOpen] = useState(false);
  // const [switchAccount, setSwitchAccount] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const userDetail = useSelector((state) => state.reducer.userDetail);
  console.log("userDetail", userDetail);
  const dispatch = useDispatch();

  useEffect(() => {
    getData(GetUserProfileApi, setProfileData, getUserProfileImg);
    const hash = window.location.hash; // e.g., "#/myprofile?response=Thank%20"
    const message = hash.split("?")[1];
    // const message = params.get("response");
    const params = new URLSearchParams(message);
    const response = params.get("response");
    if (response) {
      const decodedMessage = decodeURIComponent(response);

      // Remove text between "Thank you" and "for submitting"
      const cleanedMessage = decodedMessage.replace(
        /(Thank you)(.*?)(for submitting)/,
        "$1 $3",
      );

      //  text: response.replace(/%20/g, " "),
      Swal.fire({
        text: cleanedMessage,
        icon: "success",
        timer: 5000,
      });

      window.location.href = "https://elegantprime.in/myprofile";
      // window.location.href = "http://localhost:3000/#/myprofile";
      // console.log("@@@@@@@@@Message", cleanedMessage);
    }
  }, []);

  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={4}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E6E6FF",
          fontFamily: "'Montserrat', sans-serif",
          minHeight: "100vh",
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            mt: "10px",
            borderRadius: "5px",
            color: "#01008B", // optional text color
            textAlign: "left",
            marginBottom: "20px",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            My Profile
          </Typography>
        </Grid>
        {profileData && (
          <Grid
            item
            xs={12}
            sx={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
                gap={2}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => dispatch(setSwitchAccount(true))}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "13px",
                        md: "16px",
                        lg: "18px",
                      },
                    }}
                  >
                    Roshan
                  </Typography>
                  <KeyboardArrowDownIcon sx={{ ml: 0.5 }} />
                </Box>
                <AccountSwitcherModal
                  // open={switchAccount}
                  onClose={() => dispatch(setSwitchAccount(false))}
                />
                <Box
                  sx={{
                    height: { xs: "150px", sm: "250px", md: "150px" },
                    width: { xs: "150px", sm: "250px", md: "150px" },
                    borderRadius: "50%",
                    cursor: "pointer",
                    overflow: "hidden",
                  }}
                >
                  {!profileData.profilePicBase64 &&
                    imageContainer.length === 0 && (
                      // <Avatar
                      //   sx={{
                      //     mb: 2,
                      //     fontSize: "200px",
                      //     height: "300px",
                      //     width: "300px",
                      //     cursor: "pointer",
                      //   }}
                      //   onClick={() => {
                      //     profileImgRef.current.click();
                      //   }}
                      // />
                      <Box
                        component="img"
                        src={AvatarImg}
                        alt="Profile Avatar"
                        sx={{
                          height: "100%",
                          width: "100%",
                        }}
                        onClick={() => {
                          profileImgRef.current.click();
                        }}
                      />
                    )}

                  <input
                    type="file"
                    accept="image/*"
                    ref={profileImgRef}
                    hidden
                    onChange={(e) => {
                      let filePath = e.target.value;
                      let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;

                      if (!allowedExtensions.exec(filePath)) {
                        Swal.fire({
                          text: "Invalid file type",
                          icon: "error",

                          ...swalAlertPopProps,
                        });
                        e.target.value = "";
                        return false;
                      }
                      const file = e.target.files[0];
                      const reader = new FileReader();
                      reader.onload = (e) => {
                        const base64 = e.target.result;
                        setImageContainer(base64);
                        setProfileData({
                          ...profileData,
                          fileBase64: base64?.split(",")[1],
                        });
                      };
                      reader.readAsDataURL(file);
                    }}
                  />
                  {(profileData?.profilePicBase64 || imageContainer) && (
                    <img
                      src={imageContainer || profileData.profilePicBase64}
                      alt={"profile pic"}
                      style={{
                        height: "100%",
                        width: "100%",
                        borderRadius: "50%",
                      }}
                      onClick={() => {
                        profileImgRef.current.click();
                      }}
                    />
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} md={8}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      id="name"
                      label="Name"
                      value={profileData?.name}
                      onChange={(e) => {
                        setProfileData({
                          ...profileData,
                          name: e.target.value,
                        });
                      }}
                      InputLabelProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                        endAdornment: (
                          <EditIcon
                            sx={{
                              color: (theme) => theme.palette.primary.main,
                            }}
                          />
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id="address"
                      label="Brief Address"
                      size="small"
                      value={profileData?.address}
                      onChange={(e) => {
                        setProfileData({
                          ...profileData,
                          address: e.target.value,
                        });
                      }}
                      InputLabelProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                        endAdornment: (
                          <EditIcon
                            sx={{
                              color: (theme) => theme.palette.primary.main,
                              pointerEvents: "none",
                            }}
                          />
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      id="mobileNumber"
                      size="small"
                      label="Mobile Number"
                      value={profileData?.mobile}
                      disabled={true}
                      InputLabelProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputProps={{
                        sx: {
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <div
                      onClick={() => setOpen(true)}
                      style={{ cursor: "pointer" }}
                    >
                      <TextField
                        fullWidth
                        id="language"
                        size="small"
                        sx={{
                          cursor: "pointer",
                          "&:hover": {
                            cursor: "pointer",
                          },
                        }}
                        label="Language"
                        value={profileData?.language}
                        InputLabelProps={{
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        }}
                        InputProps={{
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        }}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={6} md={4} sm={6} xs={12}>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{
                        height: "40px",
                        marginTop: "10px",
                        fontSize: {
                          xs: "12px",
                          sm: "13px",
                          md: "14px",
                          lg: "15px",
                        },
                        fontWeight: 600,
                      }}
                      onClick={() =>
                        updateProfile(
                          validationUpdateProfile,
                          profileData,
                          Swal,
                          UpdateUserProfileApi,
                          GetUserProfileApi,
                          setProfileData,
                          getUserProfileImg,
                          UpdateUserProfileImageApi,
                        )
                      }
                    >
                      Update
                    </Button>
                  </Grid>
                  <Grid item lg={6} md={8} sm={6} xs={12}>
                    <Button
                      type="submit"
                      fullWidth
                      sx={{
                        height: "40px",
                        marginTop: "10px",
                        fontSize: {
                          xs: "12px",
                          sm: "13px",
                          md: "14px",
                          lg: "15px",
                        },
                        fontWeight: 600,
                      }}
                      variant="contained"
                      onClick={async () => {
                        // deleteUserRequest({
                        //   userId: userDetail?.userId,
                        // })
                        const token = await sessionStorage.getItem("smbToken");

                        // window.location.href =
                        //   "/account_delete_policy.html?userId=" +
                        //   encodeURIComponent(userDetail?.userId) +
                        //   "&token=" +
                        //   encodeURIComponent(token);

                        window.location.href =
                          "https://elegantprime.in/account_delete_policy.html?userId=" +
                          encodeURIComponent(userDetail?.userId);
                      }}
                    >
                      Request for delete the account
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Language open={open} setOpen={setOpen} />
      </Box>
    </>
  );
}
